import React from "react";

import {mb, onDesktop} from "@pg-design/helpers-css";
import {rpAppLink} from "@pg-mono/rp-routes";

import {Breadcrumbs} from "../../app/components/breadcrumbs/Breadcrumbs";
import {useInvestmentOfferListBreadcrumbs} from "../hooks/use_investment_offer_list_breadcrumbs";

export const InvestmentOfferListBreadcrumbs = () => {
    const breadcrumbsData = useInvestmentOfferListBreadcrumbs();

    return <Breadcrumbs css={[onDesktop(mb(1))]} homePageUrl={rpAppLink.base()} items={breadcrumbsData} />;
};
import React from "react";

import {mb, onDesktop} from "@pg-design/helpers-css";
import {rpAppLink} from "@pg-mono/rp-routes";

import {Breadcrumbs} from "../../app/components/breadcrumbs/Breadcrumbs";
import {useInvestmentOfferListBreadcrumbs} from "../hooks/use_investment_offer_list_breadcrumbs";

export const InvestmentOfferListBreadcrumbs = () => {
    const breadcrumbsData = useInvestmentOfferListBreadcrumbs();

    return <Breadcrumbs css={[onDesktop(mb(1))]} homePageUrl={rpAppLink.base()} items={breadcrumbsData} />;
};
